var render, staticRenderFns
import script from "./lemon-message-sticker.vue?vue&type=script&lang=js"
export * from "./lemon-message-sticker.vue?vue&type=script&lang=js"
import style0 from "./lemon-message-sticker.vue?vue&type=style&index=0&id=7635789a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7635789a",
  null
  
)

export default component.exports